import { apiInstance, apiInstancePublic } from "../../utils";

interface Response {
  token: string;
}

interface RequestCodePayload {
  email: string;
}

interface ConfirmCodePayload {
  email: string;
  code: string;
  password: string;
  name: string;
}

interface AuthResponse {
  token: string;
  message?: string;
}

export const authByIp = async () => {
  const response = await apiInstancePublic.get<Response>("ip/auth");

  return response.data;
};

export const requestUserCode = async (payload: RequestCodePayload) => {
  const response = await apiInstance.post<{ message: string }>(
    "ip/user/request-code",
    payload,
  );

  return response.data;
};

export const confirmUserCode = async (payload: ConfirmCodePayload) => {
  const response = await apiInstance.post<AuthResponse>(
    "ip/user/confirm-code",
    payload,
  );

  return response.data;
};

export const loginDependentUser = async (email: string, password: string) => {
  const response = await apiInstancePublic.post<AuthResponse>("ip/user/login", {
    email,
    password,
  });

  return response.data;
};
